<template>
 <div>
    <v-label :focused="focused || hasError" :color="validationState">{{label}}</v-label>
        <div :class="containerClass">
    <editor :init="init" ref="editor" @onInit="onReady" @onChange="emitChange"
    @onBlur="focused = false" @onFocus="focused = true"
    v-model="content"/>
    </div>
     <VMessages class="mt-1" :value="errorBucket" color="error"/>
  </div>

</template>

<script>

import Editor from '@tinymce/tinymce-vue'
import VInput from 'vuetify/lib/components/VInput/VInput.js';

export default {
  components: { Editor },
  extends: VInput,
  name: 'TemplateEditor',
  props: {
    baseUrl: {
      type: String,
      default: process.env.BASE_URL
    },
    value:{
      type: String,
      default: ""  
    },

    label:{
      type: String,
      default: ""  
    },
    variables:{
      type:Array,
      default(){
        return [];
      }
    },
    height:{
      type: Number,
      default: 500  
    },
  },
  watch:{
        value(val){
            if(val != null && this.content != val){
                this.content = val;
            }
        }
    },
  computed:{
        containerClass(){
            let style="editor ml-0 mt-1";
            if(this.focused){
                style += " editWithBorder";
            }

            if(this.hasError){
                style +=" errorBorder";
            }
            return style;
        }
    },
  data () {
    return {
      focused: false,
      editor: null,
      init: {
        height: this.height,
        menubar: false,
        resize: true, 
        statusbar: true, 
        branding: false, 
        toolbar: ' formatselect |'+ 
        'bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify  |'+
        ' addVariable image preview | bullist numlist  hr insertdatetime link table |  outdent indent  | removeformat', 
        theme: 'silver',
        skin:"custom",
        toolbar_mode:"wrap",
        theme_url: this.baseUrl + 'tinymce/themes/silver/theme.min.js',
        base_url: this.baseUrl + 'tinymce',
        suffix: '.min',
        plugins: 'image,wordcount,code,hr,lists,advlist,insertdatetime,link,table,autosave,preview',
        browser_spellcheck: true,
        autosave_ask_before_unload: true,
        autosave_interval: "20s",
        autosave_prefix: "tinymce-autosave-{path}{query}-{id}-",
      },
      content: "",
    }
  },
  created(){
      const that = this;
      const dialogConfig =  {
          title: 'Add Template Variable',
          body: {
            type: 'panel',
            items: [
              {
                type: 'selectbox',
                name: 'variable',
                label: 'Choose a variable',
                items: this.variables
              }
            ]
          },
          buttons: [
            {
              type: 'cancel',
              name: 'closeButton',
              text: 'Cancel'
            },
            {
              type: 'submit',
              name: 'submitButton',
              text: 'Add',
              primary: true
            }
          ],
          initialData: {
          },
          onSubmit: function (api) {
            const data = api.getData();
            const variable = data.variable;

            that.editor.execCommand('mceInsertContent', false, '<span>'+variable+'</span>');
            api.close();
          }
        };

    this.init.setup =  (editor) => {
        editor.ui.registry.addButton('addVariable', {
          icon: 'code-sample',
          tooltip: 'Add Template Variable',
          onAction: function () {
            editor.windowManager.open(dialogConfig)
          }
        })
      }
      if(this.value != null){
        this.content = this.value;
      }
      this.emitChange();
  },
  methods: {
    onReady (e) {
      this.editor = e.target;      
    },
    emitChange(){
      this.$emit("input",this.content);
    },
  }
}
</script>

<style lang="scss">
.editor{
  margin-left: 10%;
}
.editWithBorder{
    border:2px var(--v-primary-base) solid;
}

.errorBorder{
    border:2px red solid !important;
}
</style>
